import { BrowserCacheLocation, InteractionType, IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { AzureB2CProvider } from './AzureB2CContext';
import { useEffect, useState } from 'react';

const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_APP_B2C_CLIENT_ID as string,
    authority: `https://${import.meta.env.VITE_APP_B2C_TENANT_NAME}.b2clogin.com/${import.meta.env.VITE_APP_B2C_TENANT_NAME}.onmicrosoft.com/${import.meta.env.VITE_APP_B2C_POLICY_NAME}`,
    knownAuthorities: [`${import.meta.env.VITE_APP_B2C_TENANT_NAME}.b2clogin.com`],
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: true
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      }
    }
  }
};

const ErrorComponent = ({ error }: any) => {
  console.error('MSAL Authentication Error:', error);
  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>Authentication error occurred. Please try refreshing the page.</p>
      <button onClick={() => window.location.reload()}>Refresh Page</button>
    </div>
  );
};

export const AuthProvider = ({ children }: { children: React.ReactElement }) => {
  const [msalInstance, setMsalInstance] = useState<IPublicClientApplication | null>(null);

  useEffect(() => {
    const initMsalInstance = async () => {
      const instance = await PublicClientApplication.createPublicClientApplication(msalConfig);
      setMsalInstance(instance);
    };

    initMsalInstance();
  }, []);

  if (!msalInstance) {
    return <p>...</p>;
  }

  return (
    <MsalProvider instance={msalInstance}>
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} errorComponent={ErrorComponent}>
        <AzureB2CProvider>{children}</AzureB2CProvider>
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
};
